import { ReactNode } from 'react';
import { LoadingOverlay } from '@pletly/ui';

import { useGetPostDataQuery, GetPostDataQuery } from './__generated__/postData.generated';

interface Props {
	uuid: string;
	children: (post: GetPostDataQuery['post']) => ReactNode;
}

export const PostData = ({ uuid, children }: Props) => {
	const { data, loading } = useGetPostDataQuery({ variables: { postUuid: uuid } });

	if (loading) {
		return <LoadingOverlay show />;
	}

	if (!data?.post) {
		return null;
	}

	const { post } = data;

	return children(post);
};
